export enum TransactionType {
  PAYMENT_REQUEST = 0,
  PURCHASE = 1,
  UTILITY_BILL = 2,
  TOP_UP = 3,
  CARD = 4,
  ACH = 5,
  PAYMENT_OFFLINE = 6,
  INTERNET_PACKAGE = 7,
  IN_APP_PURCHASE = 10,
  REWARD = 11,
  REFUND = 12,
  WALLET = 13,
  CASH_IN = 14,
  TOLL = 15,
  TOLL_PAYOFF = 16,
  CREDIT_PURCHASE = 17,
  PAYOUT_CARD = 18,
  REFUND_MANUAL = 19,
  CONGESTION_PRICING = 20,
  REFUND_DIGIPAY = 21,
  REFUND_POS = 22,
  CASH_OUT = 23,
  THIRD_PARTY_TICKET = 24,
  REVERSE_MANUAL = 26,
  PAYMENT_LINK = 27,
  INSTALLMENT = 28,
  CREDIT_INQUIRY = 29,
  DONATION = 30,
  TRAFFIC_FINE = 31,
  PARTNER_AGENT_PAYOUT = 32,
  CREDIT_SPLIT_PURCHASE = 33,
  CREDIT_PREPAYMENT = 34,
  SUBSCRIPTION_INVOICE = 35,
  MARKETPLACE = 36,
  STOCK = 37,
  TAXI_PAYMENT = 38,
  VOUCHER = 39,
  DIGITAL_SIGNATURE = 40,
  MERCHANT_CREDIT_SETTLEMENT_FEE = 41,
  SPLIT_PURCHASE = 42,
  CREDIT_RESIDUE = 43,
  CREDIT_FILING = 44,
  TRAFFIC_FINE_INQUIRY = 45,
  CREDIT_ALLOCATION_PREPAYMENT = 46,
  REVOLVING = 47,
  BUSINESS_CASH_OUT = 48,
  BUSINESS_CASH_IN = 49,
  BUSINESS_WALLET_TRANSFER = 50,
  CREDIT_EARLY_SETTLEMENT = 51,
  PROMISSORY_NOTE_PAYMENT = 52,
  SHAHKAR_INQUIRY = 53,
  REGISTRATION_INFO_INQUIRY = 54,
  ADDRESS_INQUIRY = 55,
  CHEQUE_INQUIRY = 56,
  CORRECTIVE_PAYOUT = 57,
  CHEQUE_COLOR_INQUIRY = 58,
  PICHAK_INQUIRY = 59,
  PROMISSORY_NOTE = 60,
  PROMISSORY_NOTE_INQUIRY = 61,
  VOUCHER_COLLECT = 62,
  MERCHANT_CREDIT_REGISTRATION = 63,
  APP_SUBSCRIPTION = 64,
  ASSET_COLLATERAL_PAYMENT = 65,
  MERCHANT_SETTLEMENT = 66,
  MERCHANT_FEE = 67,
  MCI_SUBSCRIBER_INQUIRY = 68,
  CREDITWORTHINESS_INQUIRY = 69,
  IBAN_COMPLIANCE_INQUIRY = 70,
  APP_SUBSCRIPTION_ASSIGNED = 71,
  WEALTH_CASH_IN = 72,
  WEALTH_CASH_OUT = 73,
}

export enum ACTIVITY_TYPE {
  PURCHASE = 0,
  IN_APP_PURCHASE = 1,
  REFUND = 3,
  REWARD = 4,
  CREDIT_PURCHASE = 5,
  PAYMENT_OFFLINE = 10,
  PAYMENT_CARD = 12,
  PAYMENT_WALLET = 15,
  WALLET_CASH_IN = 16,
  WALLET_CASH_OUT = 17,
  WALLET_CORRECTIVE = 18,
  TOP_UP = 30,
  INTERNET_PACKAGE = 31,
  PAYMENT_LINK = 32,
  VOUCHER = 33,
  VOUCHER_COLLECT = 34,
  UTILITY_BILL = 40,
  TOLL = 70,
  TOLL_PAYOFF = 80,
  REFUND_MANUAL = 91,
  CONGESTION_PRICING = 92,
  REFUND_DIGIPAY = 93,
  REVERSE_MANUAL = 94,
  INSTALLMENT = 100,
  CREDIT_EARLY_SETTLEMENT = 101,
  THIRD_PARTY_TICKET = 110,
  CREDIT_INQUIRY = 111,
  DONATION = 112,
  TRAFFIC_FINE = 113,
  TRAFFIC_FINE_INQUIRY = 114,
  PARTNER_AGENT_PAYOUT = 120,
  CREDIT_PREPAYMENT = 130,
  MARKETPLACE = 140,
  STOCK = 150,
  SUBSCRIPTION = 160,
  TAXI_PAYMENT = 170,
  MERCHANT_CREDIT_SETTLEMENT_FEE = 180,
  DIGITAL_SIGNATURE = 190,
  CREDIT_RESIDUE = 200,
  CREDIT_FILING = 210,
  CREDIT_ALLOCATION_PREPAYMENT = 220,
  REVOLVING = 230,
  BUSINESS_CASH_OUT = 240,
  BUSINESS_CASH_IN = 241,
  BUSINESS_WALLET_TRANSFER = 242,
  PROMISSORY_NOTE = 243,
  MERCHANT_CREDIT_REGISTRATION = 244,
  APP_SUBSCRIPTION = 250,
}

export const TRANSACTION_TYPE_TRANSLATION = {
  [TransactionType.PAYMENT_REQUEST]: 'درخواست پرداخت',
  [TransactionType.PURCHASE]: 'خرید',
  [TransactionType.UTILITY_BILL]: 'قبض',
  [TransactionType.TOP_UP]: 'شارژ',
  [TransactionType.CARD]: 'کارت به کارت',
  [TransactionType.ACH]: 'پایا',
  [TransactionType.PAYMENT_OFFLINE]: 'پیوت',
  [TransactionType.INTERNET_PACKAGE]: 'بسته اینترنتی',
  [TransactionType.IN_APP_PURCHASE]: 'خرید درون برنامه',
  [TransactionType.REWARD]: 'جایزه کمپین',
  [TransactionType.REFUND]: 'اتو',
  [TransactionType.WALLET]: 'انتقال',
  [TransactionType.CASH_IN]: 'واریز',
  [TransactionType.TOLL]: 'عوارضی',
  [TransactionType.TOLL_PAYOFF]: 'عوارض معوقه',
  [TransactionType.CREDIT_PURCHASE]: 'خرید',
  [TransactionType.PAYOUT_CARD]: 'پی اوت',
  [TransactionType.REFUND_MANUAL]: 'منوال',
  [TransactionType.CONGESTION_PRICING]: 'طرح ترافیک',
  [TransactionType.REFUND_DIGIPAY]: 'کاستوم',
  [TransactionType.REFUND_POS]: 'بازگشت وجه پوز',
  [TransactionType.CASH_OUT]: 'برداشت',
  [TransactionType.BUSINESS_CASH_OUT]: 'برداشت شرکتی',
  [TransactionType.BUSINESS_CASH_IN]: 'واریز شرکتی',
  [TransactionType.BUSINESS_WALLET_TRANSFER]: 'انتقال شرکتی',
  [TransactionType.THIRD_PARTY_TICKET]: 'بلیت',
  [TransactionType.REVERSE_MANUAL]: 'برگشت خرید',
  [TransactionType.PAYMENT_LINK]: 'پرداخت درگاه شخصی',
  [TransactionType.INSTALLMENT]: 'اقساط',
  [TransactionType.CREDIT_INQUIRY]: 'اعتبارسنجی',
  [TransactionType.DONATION]: 'خیریه',
  [TransactionType.TRAFFIC_FINE]: 'خلافی خودرو',
  [TransactionType.CREDIT_PREPAYMENT]: 'پیش پرداخت',
  [TransactionType.MARKETPLACE]: 'مارکت پلیس',
  [TransactionType.TAXI_PAYMENT]: 'کرایه تاکسی',
  [TransactionType.VOUCHER]: 'ووچر',
  [TransactionType.DIGITAL_SIGNATURE]: 'امضای دیجیتال',
  [TransactionType.CREDIT_RESIDUE]: 'بازگشت باقی مانده اعتبار',
  [TransactionType.CREDIT_FILING]: 'هزینه ثبت نام',
  [TransactionType.TRAFFIC_FINE_INQUIRY]: 'استعلام خلافی',
  [TransactionType.CREDIT_ALLOCATION_PREPAYMENT]: 'هزینه خدمات و زیرساخت اقساطی',
  [TransactionType.REVOLVING]: 'ترمیم سقف اعتبار',
  [TransactionType.SUBSCRIPTION_INVOICE]: 'حق اشتراک',
  [TransactionType.STOCK]: 'سهام',
  [TransactionType.CREDIT_EARLY_SETTLEMENT]: 'پرداخت زودتر از موعد',
  [TransactionType.PROMISSORY_NOTE]: 'سفته الکترونیک',
  [TransactionType.MERCHANT_CREDIT_SETTLEMENT_FEE]: 'کارمزد تسویه زودتر از موعد فروشندگان',
  [TransactionType.CORRECTIVE_PAYOUT]: 'اصلاحی پیوت',
  [TransactionType.VOUCHER_COLLECT]: 'جمع ووچر',
  [TransactionType.MERCHANT_CREDIT_REGISTRATION]: 'هزینه ثبت‌نام فروشندگان',
  [TransactionType.APP_SUBSCRIPTION]: 'خرید اشتراک',
};
